type Input = {
  storageKey: string
  uuid?: string
}

export const getUuidStorageKey = ({ storageKey, uuid }: Input) => uuid ? `${uuid}:${storageKey}` : storageKey
